import React from "react";
import {useTranslation} from "react-i18next";
import {clsx} from "clsx";
import {driverName, driverNameInvited} from "utils/utility";
import {getTextClassNameByPersonType} from "utils/driverUtils";
import {PersonType} from "types/enums/PersonType";
import {Driver} from "types/entities/Driver";
import {ReservationDriver} from "types/entities/ReservationDriver";
import {UserType} from "types/enums/UserType";
import AccessTicketDriversAssignUserButton from "./AccessTicketDriversAssignUserButton";
import FeatherIcon from "components/FeatherIcon";

const AccessTicketDriverAssigned = (props: {driver: ReservationDriver; onClick: () => void; isInvited?: boolean; isLoading?: number | null}) => {
    const {t} = useTranslation();
    const assignedDriver = props.driver.driver;
    const driverNameFix = driverName(assignedDriver as Driver) == " " ? "-----" : null;

    console.log(assignedDriver);
    if (!assignedDriver) {
        return null;
    }

    return (
        <AccessTicketDriversAssignUserButton
            backIcon={<FeatherIcon className={"size-[20px] md:size-[30px]"} name={"edit"} strokeWidth={2} />}
            className={"AccessTicketDriverAssigned"}
            frontIcon={
                <FeatherIcon
                    className={clsx(
                        "size-[20px] md:size-[30px] flex-none",
                        getTextClassNameByPersonType(props.isInvited ? "invited" : assignedDriver.person_type)
                    )}
                    name={"user"}
                    strokeWidth={2}
                />
            }
            onClick={props.isInvited ? () => {} : props.onClick}
            isInvited={props.isInvited}
            isLoading={props.driver.driver_id === props.isLoading}
        >
            <div className={"flex flex-row grow"}>
                <div className={"flex flex-row grow max-w-[400px] justify-between items-start gap-x-4 py-1"}>
                    <div className="flex flex-col items-start  font-medium text-left ">
                        <span className={"leading-normal"}>
                            {props.isInvited ? driverNameFix ?? driverNameInvited(assignedDriver) : driverNameFix ?? driverName(assignedDriver)}
                        </span>
                        <span
                            className={clsx(
                                "font-light text-xxs md:text-sm leading-[1]",
                                getTextClassNameByPersonType(props.isInvited ? "invited" : (assignedDriver.person_type as unknown as PersonType))
                            )}
                        >
                            {props.isInvited ? t("Invited account") : assignedDriver.user_type == UserType.Guest ? t("Guest account") : t("Main account")}
                        </span>
                    </div>
                    {!props.isInvited && assignedDriver.age && (
                        <div className={"h-full flex flex-col items-center justify-center grow text-xs md:text-base font-light text-black"}>
                            {assignedDriver.age}&nbsp;J.
                        </div>
                    )}
                </div>
            </div>
        </AccessTicketDriversAssignUserButton>
    );
};

export default AccessTicketDriverAssigned;
